var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0003 44.3346C14.3225 44.3346 5.66699 35.6791 5.66699 25.0013C5.66699 14.3235 14.3225 5.66797 25.0003 5.66797C35.6781 5.66797 44.3337 14.3235 44.3337 25.0013C44.3337 35.6791 35.6781 44.3346 25.0003 44.3346Z",
    stroke: "#475467",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.375 30.2109C34.375 30.2109 31.25 34.3776 25 34.3776C18.75 34.3776 15.625 30.2109 15.625 30.2109",
    stroke: "#475467",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.292 18.7513C32.0157 18.7513 31.7508 18.6416 31.5554 18.4462C31.3601 18.2509 31.2503 17.9859 31.2503 17.7096C31.2503 17.4334 31.3601 17.1684 31.5554 16.9731C31.7508 16.7777 32.0157 16.668 32.292 16.668C32.5683 16.668 32.8332 16.7777 33.0286 16.9731C33.2239 17.1684 33.3337 17.4334 33.3337 17.7096C33.3337 17.9859 33.2239 18.2509 33.0286 18.4462C32.8332 18.6416 32.5683 18.7513 32.292 18.7513ZM17.7087 18.7513C17.4324 18.7513 17.1674 18.6416 16.9721 18.4462C16.7767 18.2509 16.667 17.9859 16.667 17.7096C16.667 17.4334 16.7767 17.1684 16.9721 16.9731C17.1674 16.7777 17.4324 16.668 17.7087 16.668C17.9849 16.668 18.2499 16.7777 18.4452 16.9731C18.6406 17.1684 18.7503 17.4334 18.7503 17.7096C18.7503 17.9859 18.6406 18.2509 18.4452 18.4462C18.2499 18.6416 17.9849 18.7513 17.7087 18.7513Z",
    fill: "#475467",
    stroke: "#475467",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.f60a1b62439554619f8659da7d6f62a1.svg";
export { ForwardRef as ReactComponent };